import React from 'react';
import {
  Box,
  Container,
  Grid,
  Card,
  CardContent,
  CardActionArea,
  Typography,
} from '@mui/material';
import {
  LocalLaundryService as SoffIcon,
  LineWeight as BulkIcon,
  DesignServices as CadIcon,
  ArrowForward as ArrowIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const managers = [
  {
    id: 'soff',
    title: 'Printing S/OFF Management',
    description: 'View and manage S/OFF Trello boards, dashboard analytics, board view, and printability reports.',
    icon: <SoffIcon sx={{ fontSize: 60 }} />,
    path: '/printing-process-system/soff',
  },
  {
    id: 'bulk',
    title: 'Printing Bulk Management',
    description: 'Track bulk printing jobs, LBS weights, section-wise statistics, and generate bulk PDF reports.',
    icon: <BulkIcon sx={{ fontSize: 60 }} />,
    path: '/printing-process-system/bulk',
  },
  {
    id: 'cad',
    title: 'Printing CAD Management',
    description: 'Browse and manage CAD design cards, search by list, and export CAD data to Excel.',
    icon: <CadIcon sx={{ fontSize: 60 }} />,
    path: '/printing-process-system/cad',
  },
];

const COLOR = '#00695C';

const PrintingManagerSelection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100%', py: 6, backgroundColor: '#f5f5f5' }}>
      <Container maxWidth="lg">
        {/* Header */}
        <Box textAlign="center" mb={6}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, color: COLOR, mb: 1 }}
          >
            Printing Process Management
          </Typography>
          <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 300 }}>
            Select a management board to access
          </Typography>
        </Box>

        {/* Manager Cards */}
        <Grid container spacing={4} justifyContent="center">
          {managers.map((m) => (
            <Grid item xs={12} sm={6} md={4} key={m.id}>
              <Card
                elevation={4}
                sx={{
                  height: '100%',
                  borderTop: `4px solid ${COLOR}`,
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: `0 12px 28px rgba(0, 105, 92, 0.25)`,
                  },
                }}
              >
                <CardActionArea
                  onClick={() => navigate(m.path)}
                  sx={{ height: '100%', p: 3 }}
                >
                  <CardContent sx={{ textAlign: 'center' }}>
                    {/* Icon circle */}
                    <Box
                      sx={{
                        display: 'inline-flex',
                        p: 2.5,
                        borderRadius: '50%',
                        backgroundColor: `${COLOR}18`,
                        mb: 3,
                      }}
                    >
                      <Box sx={{ color: COLOR }}>{m.icon}</Box>
                    </Box>

                    <Typography
                      variant="h6"
                      gutterBottom
                      sx={{ fontWeight: 700, color: COLOR, lineHeight: 1.3 }}
                    >
                      {m.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 3, lineHeight: 1.6 }}
                    >
                      {m.description}
                    </Typography>

                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      gap={0.5}
                      sx={{ color: COLOR, fontWeight: 600 }}
                    >
                      <Typography variant="button" sx={{ fontWeight: 700 }}>
                        Open Manager
                      </Typography>
                      <ArrowIcon fontSize="small" />
                    </Box>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default PrintingManagerSelection;
